<template>
  <div class="input-group">
    <!-- <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field v-model="node.name" label="Name" hide-details>
        </v-text-field>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field
          v-model="property.service_name"
          label="Service name"
          hide-details
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        >
        </v-text-field>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.service_name"
          :drawFlowItems="drawFlowItems"
          :property="'service_name'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-select
          class="m-auto"
          v-model="property.service_type"
          :items="type"
          item-text="label"
          item-value="value"
          label="Service type"
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-select
          class="m-auto"
          v-model="property.status"
          :items="status"
          item-text="label"
          item-value="value"
          label="Result"
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field
          v-model="property.sub_status"
          label="Sub status"
          hide-details
        >
        </v-text-field>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
        <div class="m-t-15 m-b-10">Metadata</div>
        <v-textarea
          class="textarea-input overflow-x"
          v-model="property.metadata"
          placeholder="JSON format"
          solo
          hide-details
          :rows="4"
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        ></v-textarea>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.metadata"
          :drawFlowItems="drawFlowItems"
          :property="'metadata'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="d-flex pb-0">
        <div class="width100">
          Also create a checkpoint "{{ serviceName(property) }}"
        </div>
        <v-switch
          v-model="property.create_checkpoint"
          inset
          dense
          hide-details
        ></v-switch>
      </v-col>
    </v-row>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import NoteComponent from '../../../components/note'
import apiReport from '@/apis/report'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===
export default {
  props: {
    node: Object,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  components: {
    NoteComponent,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  watch: {
    'property.service_name': {
      handler(value) {
        this.node.name = value
      }
    }
  },
  data() {
    return {
      property: {},
      type: [],
      status: [
        { label: 'Incomplete', value: 'unknown' },
        { label: 'Success', value: 'success' },
        { label: 'Failed', value: 'fail' }
      ],
      // === use for Intellisense ===
      start: -1,
      enterIntellisense: 0,
      isKeyTab: false,
      eventKey: ''
      // === use for Intellisense ===
    }
  },
  async created() {
    this.property = this.node.property
    await this.getListServiceLogType()
  },
  methods: {
    serviceName(property) {
      if (['success', 'fail'].includes(property.status)) {
        const status = _.find(this.status, { value: property.status })
        if (status) {
          return `${property.service_name} - ${status.label}`
        }
      }

      return property.service_name
    },
    async getListServiceLogType() {
      try {
        const getServiceLogType = await apiReport.getListServiceLogType()
        const { data } = getServiceLogType

        this.type = data
      } catch (error) {}
    },
    // === use for Intellisense ให้ keyup keyDown ได้ ===
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter(e) {
      if (e.keyCode === 13 && this.start > -1) {
        this.eventKey = 'enter'
        this.start = -1
        e.preventDefault()
      }
      this.eventKey = 'enter'
      this.start = -1
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      if (property == 'service_name') {
        this.property.service_name = data
      } else if (property == 'metadata') {
        this.property.metadata = data
      }
    }
    // === use for Intellisense ให้ keyup keyDown ได้ ===
  }
}
</script>

<style scoped lang="scss">
::v-deep .v-input--selection-controls__input {
  margin-right: -10px;
}
</style>
